<header class="app-header" [class.no-shadow]="noShadow">
  <app-logo-header
    [(menuOpen)]="menuOpen"
    [customer]="customer()"></app-logo-header>
  <div
    [ngStyle]="{
      padding:
        !shopHeader || isFirstLogin() ? '30px 100px' : '24px 100px 100px 100px'
    }"
    class="main-header">
    <app-resident-selector
      *ngIf="customer() && shopHeader && !isFirstLogin()"
      (backdropVisible)="isBackdropVisible = $event"></app-resident-selector>
  </div>
</header>
<app-resident-sub-header
  [class.disableEvents]="isBackdropVisible"
  style="z-index: 100; position: relative"
  *ngIf="shopHeader && !isFirstLogin()"
  [selectedResident]="resident()"
  [selectedDepartment]="department()"
  [customer]="customer()"
  (residentChanged)="residentChanged($event)"></app-resident-sub-header>
<app-page-sub-header
  *ngIf="pageHeader || isFirstLogin()"
  style="z-index: 100; position: relative"
  [isFirstLogin]="isFirstLogin() && shopHeader"
  [customer]="customer()"></app-page-sub-header>
<app-header-menu
  [(menuOpen)]="menuOpen"
  [customer]="customer()"
  [shopHeader]="shopHeader"></app-header-menu>
